/**
 * 학생 학습 통계 조회 훅.
 * `GET /app/learning/statistics`
 *
 * @returns SWR 결과. `data`는 `LearningStatisticsResponse`(챕터 수, 완료 답안 수 등).
 *
 * 파일명이 "Lerning"(오타)이지만 import 참조가 걸려 있어 그대로 둔다.
 */
import api from "pages/api/axiosInstance";
import useSWR from "swr";

export interface LearningStatisticsResponse {
  chapterCount: number;
  completedAnswerCount: number;
  questionCount: number;
  totalChapterCount: number;
}

export function useGetLearningStatistics() {
  return useSWR<LearningStatisticsResponse>(
    "/app/learning/statistics",
    (...arg) => api.get(arg[0]).then((res) => res.data.result)
  );
}
